export default "__VITE_ASSET__CDzyyeyJ__"